<script setup>
import { computed, onMounted, onUnmounted, ref } from 'vue';

const props = defineProps({
  startHour: { type: Number, required: true },
  pixelsPerHour: { type: Number, default: 60 },
});

const tick = ref(0);
let interval;
onMounted(() => {
  tick.value = 1;
  interval = setInterval(() => {
    tick.value += 1;
  }, 60000);
});
onUnmounted(() => clearInterval(interval));

const top = computed(() => {
  if (tick.value < 0) return 0; // reactive dependency touch
  const now = new Date();
  const minutes = now.getHours() * 60 + now.getMinutes() - props.startHour * 60;
  return Math.max(0, minutes * (props.pixelsPerHour / 60));
});
</script>

<template>
  <div
    class="pointer-events-none absolute left-0 right-0 z-10 flex items-center"
    :style="{ top: `${top}px` }"
  >
    <span class="-ml-1.5 h-3 w-3 rounded-full bg-n-ruby-9" />
    <span class="h-px flex-1 bg-n-ruby-9" />
  </div>
</template>
